import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  Contingent,
  StoreContingentPayload,
  UpdateContingentPayload,
} from '../../models/catalog/contingent.model';

@Injectable({ providedIn: 'root' })
export class ContingentService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  #contingents = new BehaviorSubject<Contingent[]>([]);
  public contingents$ = this.#contingents.asObservable();
  public contingents = toSignal(this.contingents$, { initialValue: [] });

  getContingents() {
    this.#http
      .get<{ data: Contingent[] }>(
        `${this.#apiUrl}/api/admin/catalog/contingents`,
      )
      .subscribe({
        next: (response) => this.#contingents.next(response.data ?? []),
        error: (e) => console.log(e),
      });
  }

  getById(id: number): Observable<{ data: Contingent }> {
    return this.#http.get<{ data: Contingent }>(
      `${this.#apiUrl}/api/admin/catalog/contingents/${id}`,
    );
  }

  create(payload: StoreContingentPayload): Observable<{ data: Contingent }> {
    return this.#http.post<{ data: Contingent }>(
      `${this.#apiUrl}/api/admin/catalog/contingents`,
      payload,
    );
  }

  update(
    id: number,
    payload: UpdateContingentPayload,
  ): Observable<{ data: Contingent }> {
    return this.#http.patch<{ data: Contingent }>(
      `${this.#apiUrl}/api/admin/catalog/contingents/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.#http.delete(
      `${this.#apiUrl}/api/admin/catalog/contingents/${id}`,
    );
  }
}
